<template>
    <div id="agent-page">

        <section-banner-small :picture-url="bannerInfo.pictureUrl" :title="bannerInfo.title" :subtitle="bannerInfo.subtitle"></section-banner-small>

        <div class="fixed-spy">
            <div class="container">
                <div class="row">

                    <!-- Side menu -->
                    <div class="d-none d-lg-block col-lg-3 lateral-menu-cont">
                        <div class="fixed-element">
                            <ul v-scroll-spy-active v-scroll-spy-link class="section-nav lateral-menu-jump">
                                <li>
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">perm_identity</i> <span class="d-none d-lg-inline">Agent information</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">favorite</i> <span class="d-none d-lg-inline">My bucket lists</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">public</i> <span class="d-none d-lg-inline">White label web</span>
                                    </a>
                                </li>
                                <a href="tel:18002314095" class="font-md link-style text-center margin-top-10 d-none d-lg-block">Call us: <span class="d-inline-block">+1 (800) 231-4095</span></a>
                            </ul>
                        </div>
                    </div>

                    <!-- Main content -->
                    <div class="col-lg-9 lateral-main-cont">
                        <div v-scroll-spy="{offset: 100}">

                            <!-- Agent Information Form Section -->
                            <section class="section-style px-xs-0">
                                <div data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="box-form bg-white box-shadow rounded">
                                                <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Agent information</h2>
                                                <user-info-form></user-info-form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <!-- My Bucket Lists Section -->
                            <section class="section-style bg-white section-style-white-lateral px-xs-0">
                                <div class="container"
                                     data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row justify-content-end">
                                        <div class="col-lg-9 lateral-main-cont">
                                            <my-bucket-lists></my-bucket-lists>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <!-- White Label Website Section -->
                            <section class="section-style px-xs-0">
                                <div data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row">
                                        <div class="col-12">
                                            <white-label-web></white-label-web>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SectionBannerSmall from "../components/sections/BannerSmall"
    import MyBucketLists from "./../components/misc/MyBucketLists"
    import WhiteLabelWeb from "../components/misc/WhiteLabelWeb";
    import UserInfoForm from "../components/misc/UserInfoForm";

    export default {
        components: {WhiteLabelWeb, SectionBannerSmall, MyBucketLists, UserInfoForm },

        data() {
            return {
                bannerInfo: {
                    title: "My bucket",
                    subtitle: "Customize your list and send them to your clients",
                    pictureUrl: "/assets/bg/profile-bg.jpeg"
                },
            };
        },
    }
</script>